import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FilterFooter } from '../../../../elements/filter-footer';
import { RadioGroup } from '../../../../elements/radio-group';


const initialValues = {
    plate: '',
    available: null
};

export const AsignacionesTabFilter = ({
    item,
    doFilter,
    close
}: {
    item?: any;
    close: () => void;
    doFilter: (item: any) => void;
}) => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        doFilter(enviaremos);
    };

    useEffect(() => {
        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Input
                            name="code"
                            label={'common.label.codigo-asignacion'}
                            type="text"
                            placeholder={'common.label.codigo-asignacion'}
                            value={values.code}
                            onChange={(value) =>
                                setFieldValue('code', value.code)
                            }
                        />

                        <Input
                            name="fullname"
                            label={'common.label.conductor'}
                            type="text"
                            placeholder={'common.label.conductor'}
                            value={values.fullname}
                            onChange={(value) =>
                                setFieldValue('fullname', value.fullname)
                            }
                        />

                        <FilterFooter
                            item={item}
                            doDelete={() => doFilter({})}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};